import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-checkliste-lkt-bioclear',
  templateUrl: './form-checkliste-lkt-bioclear.component.html',
  styleUrls: ['./form-checkliste-lkt-bioclear.component.scss', '../checklisten.scss'],
})
export class FormChecklisteLktBioclearComponent implements OnInit {
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}
}
